import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/girlchair1.png';
import usrm1 from './imgs/boychair33.png';
import chair from './imgs/tallchairwb.png';
import {showhidediv,loadwidgate,clrwidgate,gtdfltvid,setdvl,fillmsg,msgalw,getumsg} from './userdefaultdata';
import pusrf1 from './imgs/grlpfp.png';
import pusrm1 from './imgs/boypfp.png';
import {cleardv} from './clearmem';
import {Uprofile} from './Userprofile'; 
import Pvtmsgbox from './Pvtmsgbox';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
import { getmessage} from './Dynamictable';

export const Userpmusers=(arr:any)=>{
var userchats = [
		 {uid:1,mpfpid:3,utf:"1",unm:'Welcome Intrat',unrmsgs:0,mccd:'#ffff',misread:"0",smgalow:0},
		  
		  


		];
if(arr.length > 0)
userchats = arr;
//alert(JSON.stringify(userchats));
return(
     <div className="per100">
      <div className="per100" id="pvtmsgusrs">
	 <div className="postinchat" id="pvtmsgusers" style={{overflowX:'hidden',overflowY:'auto',height:''}}>
	  <div className="per100" style={{height:'auto'}}>
                      <table className="msgusertbl">
			{userchats.map((row,index)=>(
                       
			<tr><td>
                       <a href="#" className="blanka"  onClick={e=>showmgs(e,row.uid,row.smgalow)} title={row.unm} >
                       <div>
			  <div className="pmupfp">	
	  			{row.utf=="1"?(
	  			  <Girlspfp  itemid={row.mpfpid} wth={'30px'}  hgt={'35px'}/>

          			):(
          			<Boyspfp  itemid={row.mpfpid} wth={'30px'}  hgt={'35px'}/>

				)}


			    </div>
                         <div className="pvtmsgunm">
			  {row.unm}({row.unrmsgs})
			</div>
                       </div>
			</a>
			</td></tr>
                       
			))}
	   	    </table>
	 </div>	
        
	</div>
	
	</div>

     </div>
);

};
export const pvtmus=(id:any)=>{
	
	
var msgusers = [
		 {uid:0,mpfpid:0,utf:"0",unm:'',unrmsgs:0,mccd:'#ffff'},
		 

		];
getmsgusers();

};
export const configpvtmsg=(arr:any,id:any)=>{
let farr = [];
 

if(arr){
	     if(arr.length > 0){
              
		for(let i =0;i< arr.length;i++){
               
                 const rv = arr[i];
           	
		 farr.push(rv[0]);
		 
		}
	    }
	 }
 
// alert(JSON.stringify(farr));
 if(cleardv('wigtarea')){
 const msgal =0;
  const dv = document.getElementById('wigtarea') as HTMLElement;
  if(dv){
  showhidediv(true,'chatprofiledivtop');
  dv.style.display='block'; 
  if(farr){
  //if(arr.length > 0){
  const chats = Userpmusers(farr);
  ReactDOM.render(chats,dv);
  if(id > 0) {
   showmgs({},id,msgal);
 }
// }
 }
}
 }
};

export const getpvtmsgdata=(id:any)=>{
	 try {
         //const vid = localStorage.getItem("dvillaid");
	const vid = id;

         const userid = Usersession.getUserId();
         const vtype = localStorage.getItem("vilaty");
	let  service ="/getchatmsg?cid="+vid+"&uid="+userid;
        if(vtype == '2')
	 service ="/getchatmsgp?cid="+vid+"&uid="+userid;


       //alert(service);	
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              
		const tdata = response.data;
		configpvtmsg(tdata,0);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }

	
     };	
export const getmsgusers=()=>{
	 try {
         const userid = Usersession.getUserId();
       // alert(userid);
	const service ="/getmsgusers?rid="+userid;
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
		const tdata = response.data;
               // alert(JSON.stringify(tdata));
		configpvtmsg(tdata,0);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }

	
     };	

export const resizepmusr=(size:any,id:any)=>{
const pmsdv = document.getElementById('pvtmsgusers') as HTMLElement;
if(pmsdv)
pmsdv.style.height=size;

};

export const showmgs=(e:any,id:any,msgalows:any)=>{
// alert(id);
const userid = Usersession.getUserId();
const msgalwid = msgalows;
const isalow = msgalw(id,userid,msgalwid);
Usersession.setAlllowmsgId(msgalwid);
if(isalow=="OK"){

const dvu = document.getElementById('usrwidgt') as HTMLElement;
 cleardv('usrwidgt');
 if(dvu){
  dvu.style.display = 'none';
}
cleardv('msgarea');
const dv = document.getElementById('msgarea') as HTMLElement;
const msgbox = <Pvtmsgbox />
dv.style.display="block";
ReactDOM.render(msgbox,dv);
resizepmusr('42vh','pvtmsgusers');
resizepmusr('42vh','wigtarea');
if(id){
Usersession.setRcvmsguserid(id);
const rid = Usersession.getRcvmsguserid();
const userid = Usersession.getUserId();
const apimsgurl = '/getpvtmsgroom';
//alert(userid);
//alert(rid);
const obj = {sendid:userid,receiveid:rid};
getumsg(apimsgurl,obj);
}
}else{
getmessage(isalow,'');

}
};
